// extracted by mini-css-extract-plugin
export default {"statModal":"statModal_statModal__MrvF-","body":"statModal_body__0i18F","close":"statModal_close__5wO3U","avatar":"statModal_avatar__CXEo6","stat":"statModal_stat__nBlqJ"};